import ShippingMethodOption from 'components/SharedComponents/SplitEDD/ShippingMethodOption/ShippingMethodOption';

export default ShippingMethodOption;
